export default __webpack_public_path__ + "maps-examples-runtime-add-line-960-ddee61e5066e0daeb4bcf54e82d3264b.png";